import store from '@/store';
import { LOCAL_STORAGE_UNIT_ID, LOCAL_STORAGE_BRAND_ID } from '@/utils/constants/checkin.constants';

const guard = async(to, _from, next) => {
  const checkInParams = {
    brandId: store.getters.getBrandUnitIdVariables.brandId,
    unitId: store.getters.getBrandUnitIdVariables.unitId
  };
  const disabledPageReloadGuard = to.matched.some(records => records.meta.disabledPageReloadGuard);
  const isConclusionRoute = to.matched.some(records => records.meta.isConclusionRoute);
  const isPublicRoute = to.matched.some(records => records.meta.publicRoute);

  const admissionStatus = store.state.currentAdmission.data.status;
  const mdmId = store.state.mdm.data.id;

  const isAdmissionDone = admissionStatus === 'ADMISSION_DONE' || admissionStatus === 'CHECK_IN_DONE';

  const hasAccessToRoute = (disabledPageReloadGuard && isPublicRoute) || (isAdmissionDone && isConclusionRoute) || mdmId;

  window.addEventListener('beforeunload', (event) => {
    const { brandId, unitId } = checkInParams;

    localStorage.setItem(LOCAL_STORAGE_BRAND_ID, brandId);
    localStorage.setItem(LOCAL_STORAGE_UNIT_ID, unitId);
  });

  if (!hasAccessToRoute) {
    const { query } = to;
    store.commit('SET_ADMISSION_STATUS', '');

    next({
      name: 'checkIn',
      params: checkInParams,
      query,
    });
  } else {
    next();
  }
};

export default guard;
